import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import { Link } from 'react-router-dom';

export default function CoursePage() {
  useEffect(() => {
    document.title = '廿日市の塾 コース・料金｜学習塾NICK｜廿日市市中学生の少人数・個別指導';

    const setMeta = (name: string, content: string, property?: boolean) => {
      const attr = property ? 'property' : 'name';
      let el = document.querySelector(`meta[${attr}="${name}"]`) as HTMLMetaElement | null;
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    setMeta('description', '廿日市の塾・学習塾NICKのコース・料金ページ。廿日市市の中学生向けに少人数指導・個別指導・数学強化コース・サポートコースをご用意。廿日市市大野で成績アップと高校受験対策を全力サポート。無料体験受付中。');
    setMeta('keywords', '廿日市 塾 コース,廿日市 中学生 塾 料金,廿日市 少人数指導,廿日市 個別指導,廿日市 数学 塾,学習塾NICK コース');
    setMeta('og:title', '廿日市の塾 コース・料金｜学習塾NICK', true);
    setMeta('og:description', '廿日市市の中学生向け学習塾NICKのコース・料金。少人数指導・個別指導・数学強化コースなど多彩なコースで成績アップをサポート。', true);
    setMeta('og:url', `${import.meta.env.VITE_SITE_URL}/course`, true);
    setMeta('twitter:title', '廿日市の塾 コース・料金｜学習塾NICK');
    setMeta('twitter:description', '廿日市市の中学生向け学習塾NICKのコース・料金。少人数指導・個別指導で成績アップをサポート。');

    let canonical = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', `${import.meta.env.VITE_SITE_URL}/course`);

    // Schema.org JSON-LD
    const schemaId = 'schema-course-page';
    let schemaEl = document.getElementById(schemaId) as HTMLScriptElement | null;
    if (!schemaEl) {
      schemaEl = document.createElement('script');
      schemaEl.id = schemaId;
      schemaEl.type = 'application/ld+json';
      document.head.appendChild(schemaEl);
    }
    schemaEl.textContent = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "WebPage",
      "name": "廿日市の塾 コース・料金｜学習塾NICK",
      "description": "廿日市市の中学生向け学習塾NICKのコース・料金。少人数指導・個別指導・数学強化コースなど多彩なコースで成績アップをサポート。",
      "url": `${import.meta.env.VITE_SITE_URL}/course`,
      "breadcrumb": {
        "@type": "BreadcrumbList",
        "itemListElement": [
          { "@type": "ListItem", "position": 1, "name": "ホーム", "item": `${import.meta.env.VITE_SITE_URL}/` },
          { "@type": "ListItem", "position": 2, "name": "コース・料金", "item": `${import.meta.env.VITE_SITE_URL}/course` }
        ]
      },
      "mainEntity": {
        "@type": "ItemList",
        "name": "学習塾NICKのコース一覧",
        "itemListElement": [
          {
            "@type": "ListItem",
            "position": 1,
            "item": {
              "@type": "Course",
              "name": "数学強化コース(中学生)",
              "description": "基本から応用まで、高校入試に対応できる力を身に付けます。元公立高校教諭による指導。",
              "provider": { "@type": "Organization", "name": "学習塾NICK" },
              "offers": { "@type": "Offer", "price": "8000", "priceCurrency": "JPY", "description": "月額1コマ 8,000円(税込)" }
            }
          },
          {
            "@type": "ListItem",
            "position": 2,
            "item": {
              "@type": "Course",
              "name": "スタディコース",
              "description": "少人数個別指導により、分からないところを徹底理解します。",
              "provider": { "@type": "Organization", "name": "学習塾NICK" },
              "offers": { "@type": "Offer", "price": "8000", "priceCurrency": "JPY", "description": "月額1コマ 8,000円(税込)" }
            }
          },
          {
            "@type": "ListItem",
            "position": 3,
            "item": {
              "@type": "Course",
              "name": "サポートコース",
              "description": "自学自習スタイルで取り組むコース。質問しやすい環境。",
              "provider": { "@type": "Organization", "name": "学習塾NICK" },
              "offers": { "@type": "Offer", "price": "500", "priceCurrency": "JPY", "description": "1回 500円(税込)" }
            }
          },
          {
            "@type": "ListItem",
            "position": 4,
            "item": {
              "@type": "Course",
              "name": "完全個別指導コース",
              "description": "マンツーマン指導で、徹底的に理解を深めます。オンライン受講も可能。",
              "provider": { "@type": "Organization", "name": "学習塾NICK" },
              "offers": { "@type": "Offer", "price": "6000", "priceCurrency": "JPY", "description": "1回 6,000円(税込)" }
            }
          }
        ]
      }
    });

    return () => {
      document.title = '廿日市の塾なら学習塾NICK｜廿日市市の中学生塾・成績アップ・高校受験対策';
      if (canonical) canonical.setAttribute('href', `${import.meta.env.VITE_SITE_URL}/`);
      const s = document.getElementById(schemaId);
      if (s) s.remove();
    };
  }, []);

  const courses = [
    {
      name: '数学強化コース(中学生)',
      target: '中学1年生〜中学3年生',
      schedule: {
        grade1: '毎週水曜 19時〜20時',
        grade2: '毎週金曜 19時〜20時',
        grade3: '毎週火曜、木曜 19時〜20時'
      },
      features: [
        '基本から応用まで、高校入試に対応できる力を身に付けます',
        '単元ごとにポイントをしぼった教材を用意',
        '理解をより深め、入試に対応できる力を身に付けます',
        '高校入試を知り尽くした元公立高校教諭による指導'
      ],
      price: '月額1コマ 8,000円(税込)',
      image: 'https://static.readdy.ai/image/58c223b9eef17a4b88bac47f4e33252a/da10e06bfba82bacdb88594d087b0bb9.jpeg'
    },
    {
      name: 'スタディコース(どの教科でも)',
      target: '全学年対象',
      schedule: {
        all: '火曜〜金曜までの18時〜19時、20時〜21時から好きな時間帯を選択'
      },
      features: [
        '少人数個別指導により、分からないところを徹底理解します',
        '普段の学習の悩みや入試までの取り組み方についてもサポート',
        '第1志望校への合格を目指すコース',
        '一人ひとりに親身に寄り添う指導'
      ],
      price: '月額1コマ 8,000円(税込)',
      image: 'https://static.readdy.ai/image/58c223b9eef17a4b88bac47f4e33252a/6225996758aeec267422d5742c920c8b.jpeg'
    },
    {
      name: 'サポートコース',
      target: '全学年対象',
      schedule: {
        all: '月曜 18時〜19時30分'
      },
      features: [
        '自分で教材を持参、宿題や授業で分からないところを先生に質問',
        '自学自習スタイルで取り組むコース',
        '質問しやすい環境',
        '学習習慣の定着をサポート'
      ],
      price: '1回 500円(税込)',
      image: 'https://static.readdy.ai/image/58c223b9eef17a4b88bac47f4e33252a/6e13a3d80ada2eef8294b839b6e2dafb.jpeg'
    },
    {
      name: '完全個別指導コース',
      target: '全学年対象',
      schedule: {
        all: '事前に時間帯を予約'
      },
      features: [
        'マンツーマン指導で、徹底的に理解を深めます',
        '予約制になりますので事前にご連絡ください',
        '一人ひとりに合わせたオーダーメイドカリキュラム',
        '苦手科目の徹底克服',
        'オンライン受講も可能'
      ],
      price: '1回 6,000円(税込)',
      image: 'https://static.readdy.ai/image/58c223b9eef17a4b88bac47f4e33252a/1cb7cfca047af27e1f9c6a22744e553c.jpeg'
    }
  ];

  const flowSteps = [
    {
      number: '01',
      title: 'お問い合わせ',
      description: 'ホームページ、お電話、LINEからお気軽にお問い合わせください。'
    },
    {
      number: '02',
      title: '無料体験',
      description: '実際の授業を体験していただき、塾の雰囲気を確認できます。'
    },
    {
      number: '03',
      title: '学力診断・面談',
      description: '現在の学力を診断し、最適なコースと学習プランをご提案します。'
    },
    {
      number: '04',
      title: '入塾手続き',
      description: 'ご納得いただけましたら、入塾手続きを行います。'
    },
    {
      number: '05',
      title: '授業開始',
      description: '目標に向けて、一緒に頑張りましょう！'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      <main className="pt-20">
        {/* Hero Section */}
        <section className="relative py-32 bg-gradient-to-br from-[#4a90e2]/10 via-white to-[#4a90e2]/5">
          <div className="max-w-7xl mx-auto px-6 text-center">
            <h1 className="text-5xl md:text-6xl font-bold text-[#1a2332] mb-6">
              コース・料金
            </h1>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
              <strong>廿日市市大野</strong>の学習塾NICKでは、<strong>中学生</strong>一人ひとりの目標と学習状況に合わせた多彩なコースをご用意しています。<strong>少人数指導</strong>、<strong>個別指導</strong>、<strong>高校受験対策</strong>など、最適な学習スタイルをお選びいただけます。
            </p>
          </div>
        </section>

        {/* Courses Section */}
        <section className="py-24 bg-white">
          <div className="max-w-7xl mx-auto px-6">
            <div className="space-y-16">
              {courses.map((course, index) => (
                <div
                  key={index}
                  className="bg-[#f8f9fa] rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300"
                >
                  <div className="grid grid-cols-1 lg:grid-cols-5 gap-0">
                    <div className="lg:col-span-2 h-64 lg:h-auto">
                      <img
                        src={course.image}
                        alt={course.name}
                        className="w-full h-full object-cover"
                      />
                    </div>
                    
                    <div className="lg:col-span-3 p-10 md:p-12">
                      <h2 className="text-3xl md:text-4xl font-bold text-[#1a2332] mb-4">
                        {course.name}
                      </h2>
                      <div className="flex flex-wrap gap-3 mb-6">
                        <span className="bg-[#4a90e2]/10 text-[#4a90e2] px-4 py-2 rounded-full text-sm font-semibold">
                          {course.target}
                        </span>
                      </div>

                      <div className="mb-6">
                        <h3 className="text-lg font-bold text-[#1a2332] mb-3 flex items-center gap-2">
                          <i className="ri-time-line text-[#4a90e2]"></i>
                          時間割
                        </h3>
                        <div className="bg-white rounded-xl p-4 space-y-2">
                          {course.schedule.grade1 && (
                            <p className="text-gray-700"><strong>中学1年生：</strong>{course.schedule.grade1}</p>
                          )}
                          {course.schedule.grade2 && (
                            <p className="text-gray-700"><strong>中学2年生：</strong>{course.schedule.grade2}</p>
                          )}
                          {course.schedule.grade3 && (
                            <p className="text-gray-700"><strong>中学3年生：</strong>{course.schedule.grade3}</p>
                          )}
                          {course.schedule.all && (
                            <p className="text-gray-700">{course.schedule.all}</p>
                          )}
                        </div>
                      </div>

                      <div className="mb-6">
                        <h3 className="text-lg font-bold text-[#1a2332] mb-3">
                          コースの特徴
                        </h3>
                        <ul className="space-y-2">
                          {course.features.map((feature, idx) => (
                            <li key={idx} className="flex items-start gap-3">
                              <i className="ri-check-line text-xl text-[#4a90e2] mt-1 flex-shrink-0"></i>
                              <span className="text-gray-700 text-sm">{feature}</span>
                            </li>
                          ))}
                        </ul>
                      </div>

                      <div className="bg-[#4a90e2] rounded-xl p-6">
                        <p className="text-white text-2xl font-bold">
                          {course.price}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Additional Info Section */}
        <section className="py-24 bg-[#f8f9fa]">
          <div className="max-w-5xl mx-auto px-6">
            <h2 className="text-3xl md:text-4xl font-bold text-[#1a2332] mb-12 text-center">
              学習塾NICKの特徴
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
              <div className="bg-white rounded-2xl p-8 text-center">
                <div className="w-16 h-16 bg-[#4a90e2]/10 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-user-star-line text-3xl text-[#4a90e2]"></i>
                </div>
                <h3 className="text-xl font-bold text-[#1a2332] mb-3">個別指導の充実</h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  生徒1人1人に親身に寄り添い、目標とする高校合格に必要な力を身に付けさせます。
                </p>
              </div>

              <div className="bg-white rounded-2xl p-8 text-center">
                <div className="w-16 h-16 bg-[#4a90e2]/10 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-book-open-line text-3xl text-[#4a90e2]"></i>
                </div>
                <h3 className="text-xl font-bold text-[#1a2332] mb-3">質の高い授業</h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  ポイントをしぼり、入試によく出る単元の解説を中心に、質の高い数学の授業を実施しています。
                </p>
              </div>

              <div className="bg-white rounded-2xl p-8 text-center">
                <div className="w-16 h-16 bg-[#4a90e2]/10 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-calendar-check-line text-3xl text-[#4a90e2]"></i>
                </div>
                <h3 className="text-xl font-bold text-[#1a2332] mb-3">選べる学習時間</h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  事前に面談をさせていただき、最適なカリキュラムをご提案します。
                </p>
              </div>
            </div>

            <div className="bg-[#4a90e2]/5 rounded-2xl p-8">
              <h3 className="font-bold text-[#1a2332] mb-4 flex items-center gap-3">
                <i className="ri-shield-star-line text-2xl text-[#4a90e2]"></i>
                元公立高校教諭による指導
              </h3>
              <p className="text-gray-700 leading-relaxed">
                広島県公立高校教諭として10年以上勤め、多くの生徒の進路指導を経験。高校入試にとにかく詳しい講師が、中学生たちを全力でサポートします！
              </p>
            </div>
          </div>
        </section>

        {/* Flow Section */}
        <section className="py-24 bg-white">
          <div className="max-w-7xl mx-auto px-6">
            <h2 className="text-3xl md:text-4xl font-bold text-[#1a2332] mb-4 text-center">
              入塾までの流れ
            </h2>
            <p className="text-gray-600 text-center mb-16 max-w-3xl mx-auto">
              <strong>廿日市市</strong>の学習塾NICKでは、<strong>無料体験</strong>から始めていただけます。お気軽にお問い合わせください。
            </p>

            <div className="grid grid-cols-1 md:grid-cols-5 gap-6">
              {flowSteps.map((step, index) => (
                <div key={index} className="relative">
                  <div className="bg-[#f8f9fa] rounded-2xl p-6 h-full hover:shadow-lg transition-all">
                    <div className="text-5xl font-bold text-[#4a90e2]/20 mb-4">
                      {step.number}
                    </div>
                    <h3 className="text-lg font-bold text-[#1a2332] mb-3">
                      {step.title}
                    </h3>
                    <p className="text-sm text-gray-600 leading-relaxed">
                      {step.description}
                    </p>
                  </div>

                  {index < flowSteps.length - 1 && (
                    <div className="hidden md:block absolute top-1/2 -right-3 transform -translate-y-1/2 z-10">
                      <i className="ri-arrow-right-line text-3xl text-[#4a90e2]"></i>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-24 bg-[#1a2332]">
          <div className="max-w-4xl mx-auto px-6 text-center">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
              まずは無料体験からお気軽にご相談ください
            </h2>
            <p className="text-white/80 text-lg mb-10 leading-relaxed">
              <strong>廿日市市大野</strong>の学習塾NICKでは、<strong>無料体験授業</strong>を随時受け付けております。<strong>定期テスト対策</strong>や<strong>高校受験対策</strong>について、詳しくご説明いたします。<strong>廿日市市</strong>、<strong>宮島</strong>、<strong>阿品</strong>、<strong>大竹市</strong>など周辺地域からもお気軽にお越しください。
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link
                to="/trial#trial-form-section"
                className="bg-[#4a90e2] text-white px-10 py-5 rounded-full text-lg font-semibold hover:bg-[#3a7bc8] transition-all hover:scale-105 flex items-center justify-center gap-3 whitespace-nowrap cursor-pointer"
              >
                無料体験に申し込む
                <i className="ri-arrow-right-line text-xl"></i>
              </Link>
              <a
                href="tel:0829-78-1638"
                className="bg-white text-[#1a2332] px-10 py-5 rounded-full text-lg font-semibold hover:bg-gray-100 transition-all hover:scale-105 flex items-center justify-center gap-3 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-phone-line text-xl"></i>
                電話で問い合わせる
              </a>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}
